import React from 'react';

export default function FilterChips({ groups, active, onToggle }) {
    if (!groups || groups.length === 0) return null;
    return (
        <div className="apk-chips">
            {groups.map((g) => {
                if (!g.items || g.items.length === 0) return null;
                const activeSet = active[g.key] || new Set();
                return (
                    <div className="apk-chips__row" key={g.key}>
                        {g.items.map((it) => {
                            const isOn = activeSet.has(it.value);
                            return (
                                <span
                                    key={String(it.value)}
                                    className={'apk-chip' + (isOn ? ' apk-chip--on' : '')}
                                    onClick={() => onToggle(g.key, it.value)}
                                >
                                    {it.label}
                                </span>
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
}
